module.exports = __webpack_public_path__ + "img/home1.2622bdf8.png";